import { render, staticRenderFns } from "./RouterBtn.vue?vue&type=template&id=8c56e3e8&scoped=true&"
import script from "./RouterBtn.vue?vue&type=script&lang=js&"
export * from "./RouterBtn.vue?vue&type=script&lang=js&"
import style0 from "./RouterBtn.vue?vue&type=style&index=0&id=8c56e3e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c56e3e8",
  null
  
)

export default component.exports